import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Typography from "@mui/material/Typography";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CollapsibleCardProps {
  header: React.ReactNode;
  children: React.ReactNode;
  customButton?: React.ReactNode;
}

const CollapsibleCard: React.FC<CollapsibleCardProps> = ({ header, customButton, children }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <MDBox
      paddingLeft={3}
      paddingRight={3}
      sx={{
        backgroundColor: "#fff",
        paddingY: "20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        marginBottom: "15px",
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {header}
        </Typography>

        <MDBox sx={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
          {customButton && isExpanded && <MDBox marginRight={1}>{customButton}</MDBox>}
          {isExpanded ? (
            <ExpandLessIcon onClick={toggleExpand} />
          ) : (
            <ExpandMoreIcon onClick={toggleExpand} />
          )}
        </MDBox>
      </MDBox>

      {isExpanded && children}
    </MDBox>
  );
};

export default CollapsibleCard;
